import constants from '../services/constants';
import { atom } from 'recoil';

const editTeamRoleAtom = atom<boolean>({
    key: constants.editTeamRoleAtom,
    default: false,
});

export default editTeamRoleAtom;